import React, {Fragment} from "react";
import classes from 'classnames';

import FormControlBase from "./FormControl";
import Icon from "../Icon";

import '../../../assets/sass/components/forms/text-view.scss';

class TextViewWithIcon extends FormControlBase {
    render = () => {
        const sizeClass = this.getSizeFromProps();
        const colorClass = this.getColorFromProps();
        const componentClass = this.getComponentClassName();

        return (
            <div className={classes(componentClass, sizeClass, colorClass)}>
                {this.renderContent()}
            </div>
        );
    };

    renderContent = () => {
        const {icon, svg, text} = this.props;

        return (
            <Fragment>
                <Icon className="text-view--icon" icon={icon} svg={svg}/>
                <span className="text-view--text"> {text} </span>
            </Fragment>
        );
    };

    getComponentClassName = () => 'text-view with-icon';
}

export default TextViewWithIcon;
